import React, { Component } from "react";
import CreateInvoice from './CreateInvoice';
import invoiceService from '../../services/WebInvoiceService';
import LoadInvoiceForm from './LoadInvoiceForm';


export default class CreateLoadInvoice extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            initialState: this.createInitialState()
        }
    }

    createInitialState() {
        return  {
            customerId : this.props.match.params.customerId,            
            additionalCharges : '',
            companyPO : '',
            contents : '',
            credits : '',
            date : null,
            dockFees : '',
            invoiceTotal:'',
            loadNumber: '',
            location: '',
            paymentDate: null,
            postedToReceivables : '',
            referenceNumber: '',
            serviceNotes : '',
            timeCharges: '',
            unit : '',
        };
    }

    handleGenerateClick = async (invoice) => {
        await invoiceService.createLoadInvoiceSync(invoice);        
        this.props.history.push({pathname:`/customer/${invoice.customerId}/loadinvoices`});
    }

    render() {
        return (<CreateInvoice initialState={this.state.initialState} handleGenerateClick={this.handleGenerateClick} form={LoadInvoiceForm}/>)
    }    
}
